import { Component, Input, OnInit } from "@angular/core";
import { ListValueService } from "src/app/core/services/list-value.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";

@Component({
  selector: "app-comments-history-peticion",
  templateUrl: "./comments-history-peticion.component.html",
  styleUrls: ["./comments-history-peticion.component.scss"],
})
export class CommentsHistoryPeticionComponent {
  @Input() id: string;
  commentsHistory = {
    opened: false,
    loaded: false,
    data: [],
  };

  constructor(
    private listValueService: ListValueService,
    private toastrAlertService: ToastrAlertService
  ) {}

  loadCommentsHistory() {
    this.commentsHistory.opened = !this.commentsHistory.opened;
    if (!this.commentsHistory.loaded) {
      this.listValueService.listValuesCommentsHistory(this.id).subscribe(
        (data) => {
          this.commentsHistory.data = data;
          this.commentsHistory.loaded = true;
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }
}
